import React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacePrivacyPolicy } from '../../../constants/space';
import { SVGIconType } from '../../../constants/svgIcon';
import useLocale from '../../../hooks/useLocale';
import { Space } from '../../../models/SpaceStore';
import { Regions } from '../../../models/SystemStore/SystemStore';
import { getRegionInfo } from '../../../utils/region';
import { JoyajoyImage } from '../JoyajoyImage';
import { SeparatorComponent } from '../SeparatorComponent';
import { SvgIcon } from '../SVGIcon';

import styles from './ClubHeader.module.css';

type ClubHeaderProps = {
  space: Space;
  translatedRegions: Regions | undefined;
  showIconRow?: boolean;
};

export const ClubHeader: React.FC<ClubHeaderProps> = ({
  space,
  translatedRegions,
  showIconRow = true,
}) => {
  const { t } = useTranslation();

  const l = useLocale();

  const spaceIconSource = space?.icon?.publicUrls?.small ?? '';
  const spaceI18nInfo = l(space.i18nClassroomInfo);
  const spaceRegion = space.region?.included?.[0];

  return (
    <div className={styles.clubHeader}>
      {showIconRow && (
        <div className={styles.titleImageContainer}>
          <div className={styles.imageWrapper}>
            <JoyajoyImage
              resource={{ uri: spaceIconSource }}
              className={styles.image}
            />
          </div>
          <div className={styles.titleContainer}>
            <div className={styles.spaceName}>{spaceI18nInfo?.name}</div>
            <div className={styles.subtitle}>
              {spaceI18nInfo?.shortDescription}
            </div>
          </div>
        </div>
      )}

      {spaceI18nInfo?.description && (
        <div className={styles.description}>{spaceI18nInfo?.description}</div>
      )}
      <div className={styles.infoContainer}>
        <SeparatorComponent
          separator={<p className={styles.separateText}>·</p>}
        >
          <div className={styles.info}>
            <SvgIcon
              name={
                space.privacyPolicy == SpacePrivacyPolicy.Public
                  ? SVGIconType.Region
                  : SVGIconType.Lock
              }
              className={styles.privacyIcon}
            />
            <p className={styles.infoText}>
              {space.privacyPolicy === SpacePrivacyPolicy.Public
                ? t('Public')
                : t('Private')}
            </p>
          </div>
          {spaceRegion && (
            <div className={styles.info}>
              <JoyajoyImage
                className={styles.regionImage}
                resource={{ uri: getRegionInfo(spaceRegion).image ?? '' }}
              />
              <p className={styles.infoText}>
                {translatedRegions?.[spaceRegion]}
              </p>
            </div>
          )}
        </SeparatorComponent>
      </div>
    </div>
  );
};
